import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import ReactDOM from "react-dom"
import { useUserTabEditPermissionDisabled } from "../lib/usersPermissions"
import { exportWorkQStatusReport } from "../lib/fetchApi"
import { notificationActions } from "../store/notifications"
import Button from "../components/common/Button"

const overlayStyle = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1002,
}

const cardStyle = {
    backgroundColor: 'var(--background, var(--white, #fff))',
    borderRadius: 8,
    padding: '16px 20px',
    minWidth: 320,
    maxWidth: 'min(420px, 92vw)',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',
}

const titleStyle = { margin: '0 0 8px', fontSize: 16, fontWeight: 600 }
const textStyle = { margin: '0 0 16px', fontSize: 14, lineHeight: 1.45, color: 'var(--subtitle, #555)' }
const actionsStyle = { display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }

function ExportAllConfirmModal({ onConfirm, onCancel }) {
    const overlayRoot = typeof document !== 'undefined' ? document.getElementById('overlay-root') : null
    if (!overlayRoot) {
        return null
    }

    return ReactDOM.createPortal(
        <div style={overlayStyle} role="presentation" onClick={onCancel}>
            <div
                style={cardStyle}
                role="dialog"
                aria-modal="true"
                aria-labelledby="wq-stats-export-confirm-title"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 id="wq-stats-export-confirm-title" style={titleStyle}>Export all work queues?</h3>
                <p style={textStyle}>This will queue a stats report for all work queues. Continue?</p>
                <div style={actionsStyle}>
                    <Button click={onCancel} btnStyle="btn_white">Cancel</Button>
                    <Button click={onConfirm}>Confirm</Button>
                </div>
            </div>
        </div>,
        overlayRoot,
    )
}

export default function WorkQStatusExport() {
    const hasPermission = useUserTabEditPermissionDisabled('work_queues_stats_export')
    const userToken = useSelector(state => state.user.token)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [confirmOpen, setConfirmOpen] = useState(false)

    if (!hasPermission) {
        return null
    }

    function openConfirm() {
        if (loading) {
            return
        }
        setConfirmOpen(true)
    }

    async function exportHandler() {
        setConfirmOpen(false)
        setLoading(true)

        const response = await exportWorkQStatusReport(userToken)

        if (response && response.errorMessage) {
            dispatch(notificationActions.setError(response))
            setLoading(false)
            return
        }

        dispatch(notificationActions.setError({ errorMessage: 'Work queue stats report queued. It will appear in Exports shortly.', type: 'success' }))
        setLoading(false)
        navigate('/exports')
    }

    return <>
        <Button click={openConfirm} isLoading={loading}>
            <i className="ti ti-table-export"></i>
            WQ Stats
        </Button>
        {confirmOpen && (
            <ExportAllConfirmModal
                onConfirm={exportHandler}
                onCancel={() => setConfirmOpen(false)}
            />
        )}
    </>
}
